import * as React from 'react'

import { HelmetProvider } from 'react-helmet-async'

import { Provider, Toaster } from '@enechain/ecloud-designsystem'

import { ApiHeadersProvider } from './ApiHeadersProvider'
import { system } from './system'

type Props = {
  children: React.ReactNode
  /**
   * next-themes に渡す forcedTheme。
   * admin/broker/portal はライトモード固定のため省略時は 'light' を使う。
   * dev-tool は自前のダークモード切替を next-themes に委ねたいため、
   * `forcedTheme={undefined}` を明示的に渡すことで固定を解除できる
   * （React では props を明示的に渡すと `undefined` でも key 自体は存在するため、
   * デフォルト引数と区別して「固定しない」意図を表現できる）。
   */
  forcedTheme?: 'light' | 'dark'
}

const LibProvider: React.FC<Props> = ({ children, ...rest }) => {
  const forcedTheme = 'forcedTheme' in rest ? rest.forcedTheme : 'light'

  return (
    <Provider forcedTheme={forcedTheme} system={system}>
      <HelmetProvider>
        <ApiHeadersProvider>{children}</ApiHeadersProvider>
      </HelmetProvider>
      <Toaster />
    </Provider>
  )
}

export default LibProvider
